import { styled } from '@mui/material/styles';

import TextField, { TextFieldProps } from '@Components/TextField';

const StyledSearchBar = styled(TextField)<TextFieldProps>(
  ({ theme: { palette, spacing, colors } }) => ({
    '& .MuiOutlinedInput-root': {
      padding: spacing(0, 0.7, 0, 1.6),
      borderRadius: spacing(0.4, 0, 0, 0.4),

      /** FieldSet */
      '& .MuiOutlinedInput-notchedOutline': {
        borderRight: 'none',
      },

      /** Input */
      '& .MuiOutlinedInput-input': {
        padding: spacing(0.8, 0.5, 0.8, 1.2),
      },

      /** End Icon - Clear Icon */
      '& .MuiIconButton-root': {
        margin: '0',
        padding: spacing(0.5),
      },

      /** Start Icon - Search Icon */
      '& .searchIcon': {
        color: colors.inputText,
      },

      /** Disabled State Search Icon */
      '&.Mui-disabled .searchIcon': {
        color: palette.action.disabled,
      },
    },
  })
);

export default StyledSearchBar;
